import { Button, Tooltip } from "@mui/material";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
// import styles from "../laymanmain.module.css";
import styles from "../../central-doctrine/central.module.css";


export default function LymanCarouselComps({
  allComponentViewerState,
  activeIndex,
  slidercopenents,
  onNext,
  onPrevious,
  totalChapters,
  isInitialLoad,
}) {
  const router = useRouter();
  const corosalref = useRef(null);

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(
        typeof window !== "undefined" ? window.innerWidth > 1199 : false
      );
    };

    handleResize();

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  useEffect(() => {
    if (
      router.isReady &&
      router.query.section &&
      corosalref.current &&
      (isInitialLoad.current === false || allComponentViewerState)
    ) {
      corosalref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [
    activeIndex,
    allComponentViewerState,
    router.isReady,
    router.query.section
  ]);

  const CurrentImageComponent = slidercopenents[activeIndex];

  return (
    <>
      <div>
        <div className={styles.Chapters_main_wrprs}>
          <div className={styles.NextAndPrevious_btn}>
            {!allComponentViewerState && activeIndex > 0 && isDesktop && (
              <Button className={styles.previousbtn_css} onClick={onPrevious}>
                <KeyboardArrowLeftIcon className={styles.black_btn_icon} />
                <span>previous section</span>
              </Button>
            )}

            {!allComponentViewerState &&
              activeIndex < totalChapters - 1 &&
              isDesktop && (
                <Button className={styles.nextbtn_css} onClick={onNext}>
                  <span>
                    NEXT <br /> section
                  </span>
                  <ChevronRightIcon className={styles.black_btn_icon} />
                </Button>
              )}

            {!allComponentViewerState && activeIndex > 0 && !isDesktop && (
              <Tooltip title="Previous Section">
                <KeyboardArrowLeftIcon
                  className={`${styles.previous_icon_button} ${styles.black_btn_icon}`}
                  onClick={onPrevious}
                />
              </Tooltip>
            )}

            {!allComponentViewerState &&
              activeIndex < totalChapters - 1 &&
              !isDesktop && (
                <Tooltip title="Next Section">
                  <ChevronRightIcon
                    className={`${styles.next_icon_button} ${styles.black_btn_icon}`}
                    onClick={onNext}
                  />
                </Tooltip>
              )}
          </div>
          <div ref={corosalref}>
            {allComponentViewerState ? (
              slidercopenents.map((Component, index) => (
                <React.Fragment key={index}>
                  <Component />
                </React.Fragment>
              ))
            ) : CurrentImageComponent ? (
              <CurrentImageComponent />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
